import { useMemo } from 'react';

import { MagistralDrugRawMaterial } from '@dreryk/drerykweb-medicine-api';

import { StaticDataConfiguration, Table, TableKeyExtractor } from '@dreryk/react-components';

import { MagistralDrugTemplateInsert } from '../MagistralDrugReadOnly.types';

import { useMagistralDrugTemplateRawMaterialsReadOnlyTableColumns } from './MagistralDrugTemplateRawMaterialsReadOnlyTable.hooks';

// MagistralDrugRawMaterial is used as input and output value in backend, so at this point it always exists
const ketExtractor: TableKeyExtractor<MagistralDrugRawMaterial> = (bean) => bean.id!;

type MagistralDrugTemplateRawMaterialsReadOnlyTableProps = {
   readonly rawMaterials: MagistralDrugRawMaterial[];
   readonly onInsert?: MagistralDrugTemplateInsert;
};

export const MagistralDrugTemplateRawMaterialsReadOnlyTable = (
   props: MagistralDrugTemplateRawMaterialsReadOnlyTableProps
): JSX.Element => {
   const dataConfiguration = useMemo<StaticDataConfiguration<MagistralDrugRawMaterial>>(() => {
      return {
         data: props.rawMaterials,
      };
   }, [props.rawMaterials]);
   return (
      <Table<MagistralDrugRawMaterial>
         testId={'rawMaterials'}
         columns={useMagistralDrugTemplateRawMaterialsReadOnlyTableColumns(props.onInsert)}
         dataConfiguration={dataConfiguration}
         keyExtractor={ketExtractor}
         compact
      />
   );
};
